import React, { useState } from "react";
import { toast } from "react-toastify";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";

// import JS files
import MuiPagination from "../../../shares/MuiPagination";
import PanelFilter from "../../../shares/PanelFilter";
import PanelTable from "../../../shares/PanelTable";
import useFetch from "../../../../context/useFetch";
import { fixNumbers } from "../../../../utils";
// import DeliverOrderRing from "./DeliverOrderRing";
// import PrintOrderiInfoByBangle from "./PrintOrderiInfoByBangle";
import { useNavigate } from "react-router-dom";
import MuiButton from "../../../shares/MuiButton";
import PrintIcon from "@mui/icons-material/Print";
import { useUserData } from "../../../../context/UserDataContext";
import BangleOrderInput from "./BangleOrderInput";
import BangleOrderInputFirst from "./BangleOrderInputFirst";

const headersList = [
  { colName: "show_name", name: "النگو" },
  { colName: "gender", name: "سن" },
  { colName: "color", name: "رنگ" },
  { colName: "brand_name", name: "برند" },
  { colName: "total", name: "وزن" },
  { colName: "total_one", name: "ج۱" },
  { colName: "total_two", name: "ج۲" },
  { colName: "total_three", name: "ج۳" },
  { colName: "total_four", name: "ج۴" },
  { colName: "total_five", name: "ج۵" },
  { colName: "total_six", name: "ج۶" },
  { colName: "update", name:"بروز رسانی " },
  // { colName: "delivery", name: "بروز رسانی" },
  // { colName: "print", name: "چاپ سفارش" },
];
const dataKey = [
  "show_name",
  "gender",
  "color",
  "brand_name",
  "total",
  "object.count_sizes.table_diff_size_one_num",
  "object.count_sizes.table_diff_size_two_num",
  "object.count_sizes.table_diff_size_three_num",
  "object.count_sizes.table_diff_size_four_num",
  "object.count_sizes.table_diff_size_five_num",
  "object.count_sizes.table_diff_size_six_num",
];

const mobileHeadersList = [
  { colName: "show_name", name: "النگو" },
  { colName: "gender", name: "سن" },
  { colName: "color", name: "رنگ" },
  { colName: "brand_name", name: "برند" },
  { colName: "total", name: "وزن" },
];
const OrderStatusItemList = [
  {
    name: "تغییر داده نشده",
    value: "not_changed",
  },
  {
    name: "آماده ارسال ",
    value: "ready",
  },
  {
    name: "نیاز به ویراش",
    value: "not_ready",
  },
];

const OrderStatusItemZeroList = [
  {
    name: "عدم نمایش ستون صفر",
    value: "false",
  },
  {
    name: "نمایش ستون های صفر",
    value: "true",
  },
];

const TabSix = (props) => {
  const [codeFilter, setCodeFilter] = useState(null);
  const [nameFilter, setNameFilter] = useState(null);
  const [brandFilter, setBrandFilter] = useState(null);
  const [orderItemStatusFilter, setOrderItemStatusFilter] = useState(null);
  const [orderItemStatusZeroFilter, setOrderItemStatusZeroFilter] =
    useState(null);
  const [weightSum, setWeightSum] = useState(0);
  const [weightSumRed, setWeightSumRed] = useState(0);
  const [weightSumGreen, setWeightSumGreen] = useState(0);
  const [isFilterOn, setIsFilterOn] = useState(false);
  const navigate = useNavigate();

  const [brandPagination, setBrandPagination] = useState({
    current: 1,
    pageSize: 150,
    count: 0,
    next: null,
    previous: null,
  });
  const [brandsList, setBrandsList] = useState({ results: [] });
  const getBrandsApi = useFetch({
    method: "get",
    url: "Brand_Service",
    trigger: true,
    pagination: brandPagination,
    setter: setBrandsList,
    argFunc: (res) => {},
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const filterList = [
    {
      type: "textField",
      label_fa: "کد النگو",
      label_en: "code",
      state: codeFilter,
    },
    {
      type: "textField",
      label_fa: "نام النگو",
      label_en: "name",
      state: nameFilter,
    },
    {
      type: "select",
      label_fa: "برند",
      label_en: "brand",

      state: brandFilter,
      menuItems: brandsList.results,
      fromApi: true,
    },
    // {
    //   type: "select",
    //   label_fa: "وضعیت تحویل",
    //   label_en: "order_item_status",
    //   state: orderItemStatusFilter,
    //   menuItems: OrderStatusItemList,
    // },
    // {
    //   type: "select",
    //   label_fa: "نمایش جمع صفر",
    //   label_en: "zero_diff",
    //   state: orderItemStatusZeroFilter,
    //   menuItems: OrderStatusItemZeroList,
    // },
  ];
  const { userData } = useUserData();

  const [paginationPageInfo, setPaginationPageInfo] = useState({
    current: 1,
    pageSize: 30,
    count: 0,
  });
  const rowsWeightSum = (res) => {
    let sum = 0;
    let sum_red = 0;
    let sum_green = 0;
    for (let index = 0; index < res.length; index++) {
      sum = sum + parseFloat(res[index].total);
      sum_red = sum_red + parseFloat(res[index].total_red);
      sum_green = sum_green + parseFloat(res[index].total_green);
    }
    setWeightSum(sum);
    setWeightSumRed(sum_red);
    setWeightSumGreen(sum_green);
  };
  const [ringsList, setRingsList] = useState({ results: [] });
  const getRingsApi = useFetch({
    method: "get",
    url: `User_Service/${userData.username}/admin_get_bangle_from_order_item_onprogress_tab_five`,
    pagination: paginationPageInfo,
    params: {
      code: fixNumbers(codeFilter),
      brand: brandFilter == "all" ? null : brandFilter,
      name: nameFilter,
    //   order_item_status: orderItemStatusFilter,
    //   zero_diff: orderItemStatusZeroFilter,
    },
    trigger: true,
    setter: setRingsList,
    argFunc: (res) => {
      setPaginationPageInfo({
        current: res.current,
        pageSize: res.pageSize,
        count: res.count,
        next: res.next,
        previous: res.previous,
      });
      rowsWeightSum(res.results);
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const update_filter = (state, e) => {
    if (state == "code") setCodeFilter(e.length > 0 ? e : null);
    if (state == "name") setNameFilter(e.length > 0 ? e : null);
    if (state == "brand") setBrandFilter(e);

    if (state == "order_item_status")
      setOrderItemStatusFilter(e.length > 0 ? e : null);
    if (state == "zero_diff")
      setOrderItemStatusZeroFilter(e.length > 0 ? e : null);
  };
  const filter = () => {
    if (
      codeFilter !== null ||
      nameFilter !== null ||
      brandFilter !== null ||
      orderItemStatusFilter !== null ||
      orderItemStatusZeroFilter !== null
    ) {
      setIsFilterOn(true);
      setRingsList({ results: [] });

      getRingsApi.reFetch();
    }
  };
  const reset_filter = () => {
    setCodeFilter(null);
    setNameFilter(null);
    setBrandFilter(null);
    setOrderItemStatusFilter(null);
    setOrderItemStatusZeroFilter(null);
    setRingsList({ results: [] });

    getRingsApi.reFetch();
  };
  const actionsList = [];
  // const buttonsList = [
  // {
  //   label: "بروز رسانی سفارش",
  //   component: (it) => (
  //     <DeliverOrderRing
  //       RemoveOrder
  //       selectedRow={it}
  //       getRingsApi={getRingsApi}
  //     />
  //   ),
  // },
  // {
  //   label: "چاپ",
  //   component: (it) => <PrintOrderiInfoByBangle selectedRow={it} />,
  // },
  // ];

  const buttonsList = [
    {
      //   label: "بروز رسانی ",
      component: (it) => (
        <BangleOrderInputFirst selectedRow={it} getRequestListApi={getRingsApi} />
      ),
    },
  ];
  const onChangePage = (e, page) => {
    setPaginationPageInfo({
      ...paginationPageInfo,
      current: page,
    });
    setRingsList({ results: [] });
    getRingsApi.reFetch();
  };
  const handelPrintReport = () => {
    // navigate(
    //   `/print-customers-current-orders-by-bangle/${codeFilter}/${nameFilter}/${brandFilter}/${orderItemStatusFilter}/${orderItemStatusZeroFilter}`
    // );
    window.open(
      `/print-customers-current-orders-by-bangle/${codeFilter}/${nameFilter}/${brandFilter}/${orderItemStatusFilter}/${orderItemStatusZeroFilter}`,
      "_blank"
      // "rel=noopener noreferrer"
    );
  };

  return (
    <>
      <PanelFilter
        header="فیلتر سفارش‌ها:"
        list={filterList}
        update_filter={update_filter}
        filter={filter}
        reset_filter={reset_filter}
      />
      <div className="flex justify-end">
        <MuiButton
          onClick={handelPrintReport}
          variant="outlined"
          icon={<PrintIcon />}
          color="primary"
          text="چاپ گزارش"
          margin="mr-2"
        />
      </div>
      <>
        <PanelTable
          header="لیست سفارش‌های جاری براساس النگو:"
          headers={headersList}
          mobileHeaders={mobileHeadersList}
          data={ringsList.results}
          dataKey={dataKey}
          buttons={buttonsList}
          actions={actionsList}
          icon={<AccountBalanceIcon />}
        />
        <div className="border py-2 text-sm text-myblue-100 font-bold">
          <div className="flex items-center">
            <div className="mx-6">
              <span className="">جمع وزن کل:</span>
              <span className="mr-4">{weightSum.toFixed(3)} گرم</span>
            </div>
            <div className="mx-6">
              <span className="">جمع تحویلی:</span>
              <span className="mr-4">{weightSumGreen.toFixed(3)} گرم</span>
            </div>
            <div>
              <span className="">جمع کسری:</span>
              <span className="mr-4">{weightSumRed.toFixed(3)} گرم</span>
            </div>
          </div>
        </div>
        <MuiPagination
          onChange={onChangePage}
          count={Math.ceil(
            paginationPageInfo.count / paginationPageInfo.pageSize
          )}
        />
      </>
    </>
  );
};

export default TabSix;
